import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { createAllEventParticipantsRequestedAction } from '../../../actions/participantActions';
import { SimpleModalId } from '../../../constants/modalId';
import { getAegisubNamesFromParticipants } from '../../../helpers/aegisubHelper';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import { baseMapDispatchToProps, baseMapStateToProps } from '../../componentBase';

import {
  AegisubDataModal,
  AegisubDataModalDispatchProps,
  AegisubDataModalOwnProps,
  AegisubDataModalStateProps,
} from './aegisubDataModal';

class AegisubNamesModal extends AegisubDataModal {
  constructor(props: any) {
    super(SimpleModalId.AegisubNames, props);
    this.state = {
      getDataToCopy: getAegisubNamesFromParticipants,
      text: 'Copy the data here into Aegisub to start clipping',
      title: 'Aegisub Participant Names',
      warningText: 'NOTE: The commas have been removed from names and subtitles to enable later processing',
    };
  }
}

function mapStateToProps(state: ClippingPlatformState, ownProps: AegisubDataModalOwnProps): AegisubDataModalStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);

  return {
    ...baseMapStateToProps(state),
    participants: getAllWithIds(state.entities.participants, event.participants),
  };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: AegisubDataModalOwnProps): AegisubDataModalDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadEventParticipants: (c: AegisubDataModal) =>
      dispatch(createAllEventParticipantsRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AegisubNamesModal);
